module.exports = __webpack_public_path__ + "img/certificate1-05.269ead39.png";